var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("v-data-table", {
        attrs: {
          items: _vm.clientApplicationsList,
          headers: _vm.headers,
          loading: _vm.clientApplicationsGetting,
          search: _vm.search
        },
        scopedSlots: _vm._u([
          {
            key: "body.prepend",
            fn: function() {
              return [
                _c("tr", [
                  _c(
                    "td",
                    { attrs: { colspan: _vm.headers.length } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "3" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "search",
                                  "append-icon": "mdi-magnify"
                                },
                                model: {
                                  value: _vm.search,
                                  callback: function($$v) {
                                    _vm.search = $$v
                                  },
                                  expression: "search"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "item.created_at",
            fn: function({ value }) {
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      value.dateFormat({ hour: "numeric", minute: "numeric" })
                    )
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }